<section class="flex w-full h-full p-20 md:p-30 bg-top bg-no-repeat bg-cover bg-fixed"
  style="background: url(./assets/images/wave-bg-mint-dark2.svg)">
  <section class="flex w-full h-full">
    @if (!isLoading) {
    <section class="grid w-full grid-cols-4 gap-20 mx-auto lg:gap-30" [@fadeIn]="!isLoading">      
      <section class="flex flex-col text-center col-span-6 lg:col-span-2 md:col-span-2 sm:col-span-6 card p-30 gap-y-5">
        <div class="flex flex-col gap-y-10 pb-10">
          <h2 class="font-bold">Recent Communications</h2>
          <p class="text-sm text-gray h-36">No need to dig through emails—everything is in one place.</p>
        </div>
        <div class="flex overflow-auto h-240">
          @if (recentCommunicationSection?.AllAssets) {
          <ul class="flex flex-col w-full">
            @for (a of recentCommunicationSection?.AllAssets; track a) {
            <li class="flex p-10 text-sm">
              <div class="w-full"
                [class]="a.Asset.mediaType === 'Video' ? 'wistia_embed wistia_async_' + a.Asset.assetId + ' popover=true popoverContent=link inline relative' : ''">
                <div class="flex justify-start items-center">
                  @if (a.Asset.mediaType === 'File') {
                  <img class="h-24" src="assets/images/ico_document.png" />
                  }
                  @if (a.Asset.mediaType === 'Video') {
                  <img class="h-24" src="assets/images/ico_video.png" />
                  }
                  <a class="ml-10 font-semibold underline text-gray-dark text-m hover:text-mint-darker focus:text-mint-darker"
                    [href]="a.Asset.mediaType === 'Video' ? '#' : 'api/wistia/assets/' + a.Asset.assetId"
                    [attr.target]="a.Asset.mediaType === 'Video' ? null : '_blank'"
                    [attr.aria-label]="'Open ' + a.Asset.name" rel="noopener">{{a.Asset.name}}</a>
                </div>
              </div>
            </li>
            }
          </ul>
          }
          @if (!recentCommunicationSection?.AllAssets) {
          <div class="mt-50 text-mint-darker">
            Stay tuned! New details coming soon!
          </div>
          }
        </div>
      </section>      
      <section class="flex flex-col text-center col-span-6 lg:col-span-2 md:col-span-2 sm:col-span-6 card p-30 gap-y-5">
        <div class="flex flex-col gap-y-10 pb-10">
          <h2 class="font-bold">Alphastar Content Library</h2>
          <p class="text-sm text-gray h-36">Client-facing materials designed to help advisors break down complex
            concepts and address common investment concerns.</p>
        </div>
        <div class="flex overflow-auto h-240">
          @if (alphastarContentLibrarySection?.AllAssets) {
          <ul class="flex flex-col w-full">
            @for (a of alphastarContentLibrarySection?.AllAssets; track a) {
            <li class="flex p-10 text-sm">
              <div class="w-full"
                [class]="a.Asset.mediaType === 'Video' ? 'wistia_embed wistia_async_' + a.Asset.assetId + ' popover=true popoverContent=link inline relative' : ''">
                <div class="flex justify-start items-center">
                  @if (a.Asset.mediaType === 'File') {
                  <img class="h-24" src="assets/images/ico_document.png" />
                  }
                  @if (a.Asset.mediaType === 'Video') {
                  <img class="h-24" src="assets/images/ico_video.png" />
                  }
                  <a class="ml-10 font-semibold underline text-gray-dark text-m hover:text-mint-darker focus:text-mint-darker"
                    [href]="a.Asset.mediaType === 'Video' ? '#' : 'api/wistia/assets/' + a.Asset.assetId"
                    [attr.target]="a.Asset.mediaType === 'Video' ? null : '_blank'"
                    [attr.aria-label]="'Open ' + a.Asset.name" rel="noopener">{{a.Asset.name}}</a>
                </div>
              </div>
            </li>
            }
          </ul>
          }
          @if (!alphastarContentLibrarySection?.AllAssets) {
          <div class="mt-50 text-mint-darker">
            Stay tuned! New details coming soon!
          </div>
          }
        </div>
        @if (alphastarContentLibrarySection?.AllAssets) {
        <a [routerLink]="['../alphastar-content-library']" routerLinkActive="router-link-active"
          class="flex items-center mt-auto ml-auto text-xs font-bold uppercase gap-x-5 text-mint-darker">
          <span>View More</span>
          <mat-icon svgIcon="arrow-right" class="mi-18"></mat-icon>
        </a>
        }
      </section>
      <section class="flex flex-col text-center col-span-6 lg:col-span-2 md:col-span-2 sm:col-span-6 card p-30 gap-y-5">
        <div class="flex flex-col gap-y-10">
          <h2 class="font-bold">Webinars</h2>
          <p class="text-sm text-gray h-64">Stay informed and up-to-date through our collection of recorded webinars.
          </p>
        </div>
        <p class="text-sm font-semibold">{{virtualLearningHighlightVideo?.name}}</p>
        <div class="mx-auto overflow-hidden rounded wistia_responsive_wrapper h-150 w-256">
          <span
            class="wistia_embed wistia_async_{{virtualLearningHighlightVideo?.assetId}} popover=true popoverAnimateThumbnail=false videoFoam=false videoQuality=hd-only h-full w-full inline-block"> </span>
        </div>
        <a [routerLink]="['../virtual-learning-series']" routerLinkActive="router-link-active"
          class="flex items-center mt-auto ml-auto text-xs font-bold uppercase gap-x-5 text-mint-darker">
          <span>View More</span>
          <mat-icon svgIcon="arrow-right" class="mi-18"></mat-icon>
        </a>
      </section>
      <section class="flex flex-col text-center col-span-6 lg:col-span-2 md:col-span-2 sm:col-span-6 card p-30 gap-y-5">
        <div class="flex flex-col gap-y-10">
          <h2 class="font-bold">Sales Summit 2025</h2>
          <p class="text-sm text-gray h-64">
            Check out the presentations from our May 2025 Sales Summit in Charlotte, NC!
          </p>
        </div>
        <p class="text-sm font-semibold">{{salesSummitHighlightVideo?.name}}</p>
        <div class="mx-auto overflow-hidden rounded wistia_responsive_wrapper h-150 w-256">
          <span
            class="wistia_embed wistia_async_{{salesSummitHighlightVideo?.assetId}} popover=true popoverAnimateThumbnail=false videoFoam=false videoQuality=hd-only h-full w-full inline-block"> </span>
        </div>
        <a [routerLink]="['../sales-summit']" routerLinkActive="router-link-active"
          class="flex items-center mt-auto ml-auto text-xs font-bold uppercase gap-x-5 text-mint-darker">
          <span>View More</span>
          <mat-icon svgIcon="arrow-right" class="mi-18"></mat-icon>
        </a>
      </section>
      <!-- <section class="flex flex-col text-center col-span-6 lg:col-span-2 md:col-span-2 sm:col-span-6 card p-30 gap-y-5">
          <div class="flex flex-col gap-y-10">
            <h2 class="font-bold">Coffee with Compliance</h2>
            <p class="text-sm text-gray h-64">Quick, digestible tips and reminders to help you stay protected.</p>
          </div>
          <p class="text-sm font-semibold">{{coffeeComplianceHighlightVideo?.name}}</p>
          <div class="mx-auto overflow-hidden rounded wistia_responsive_wrapper h-150 w-256">
            <span
            class="wistia_embed wistia_async_{{coffeeComplianceHighlightVideo?.assetId}} popover=true popoverAnimateThumbnail=false videoFoam=false videoQuality=hd-only h-full w-full inline-block"> </span>
          </div>
          <a [routerLink]="['../coffee-with-compliance']" routerLinkActive="router-link-active"
            class="flex items-center mt-auto ml-auto text-xs font-bold uppercase gap-x-5 text-mint-darker">
            <span>View More</span>
            <mat-icon svgIcon="arrow-right" class="mi-18"></mat-icon>
          </a>
        </section> -->
      <!-- @if (showNextLevelSection) {
      <section
        class="flex flex-row items-center col-span-4 lg:col-span-4 md:col-span-4 sm:col-span-6 card p-30 gap-x-30 gap-y-30">
        <div class="flex items-center w-full mr-auto gap-x-30">
          <div class="block w-full max-w-350 min-w-192">
            <img class="block w-auto mx-auto h-128 " src="assets/images/logos/next-level-logo.png"
              alt="Next Level Resources">
          </div>
          <div class="flex flex-col gap-y-10">
            <p>Gain access to a solutions-based development program, led by industry expert and coach, Paul Housey, CPA,
              CFP®, CLU®, designed to empower you with the necessary skills and knowledge to take your practice to the
              Next Level.</p>
            <a [routerLink]="['../next-level']" routerLinkActive="router-link-active"
              class="flex items-center justify-center mt-10 mr-auto text-xs font-bold uppercase gap-x-5 text-mint-darker">
              <span>View More</span>
              <mat-icon svgIcon="arrow-right" class="mi-18"></mat-icon>
            </a>
          </div>
        </div>
        <div class="flex flex-row items-center justify-between mx-auto w-400 gap-x-40">
          @for (asset of nextLevelSection?.VideoAssets; track asset; let index = $index) {
          <app-development-center-wistia-media class="justify-center" [model]="asset">
          </app-development-center-wistia-media>
          }
        </div>
      </section>
      } -->
    </section>
    }
  </section>
</section>